import { useParams } from "react-router-dom";
import { useGetGoalsDetails } from "../../../../../hooks/api/queries/usePerformance";
import { useState } from "react";

export const useGoalsDetails = () => {
  const { id } = useParams();
  const [isDeleteGoal, setIsDeleteGoal] = useState(null);
  const [isUpdateGoalsDetails, setIsUpdateGoalsDetails] = useState(null);
  const { isLoading: isLoadingGoals, data: goalsDetails } = useGetGoalsDetails({
    id,
  });

  return {
    isLoadingGoals,
    isDeleteGoal,
    goalsDetails,
    isUpdateGoalsDetails,
    setIsUpdateGoalsDetails,
    setIsDeleteGoal,
  };
};
